import React from 'react';
import type { NameComponent } from '../../../types/builder';

interface NameRendererProps {
  component: NameComponent;
}

export const NameRenderer: React.FC<NameRendererProps> = ({ component }) => {
  const { name, title, nameSize, titleSize, nameColor, titleColor, backgroundColor, alignment, padding, style } = component.settings;

  const nameStyle = style || 'default';

  // Default Style
  if (nameStyle === 'default') {
    return (
      <div style={{ backgroundColor, padding: `${padding}px`, textAlign: alignment }}>
        <div className="max-w-4xl mx-auto">
          <h1 style={{ fontSize: `${nameSize}px`, color: nameColor, fontWeight: 'bold', marginBottom: '8px' }}>
            {name}
          </h1>
          {title && (
            <p style={{ fontSize: `${titleSize}px`, color: titleColor }}>
              {title}
            </p>
          )}
        </div>
      </div>
    );
  }

  // Modern Style
  if (nameStyle === 'modern') {
    return (
      <div style={{ backgroundColor, padding: `${padding}px`, textAlign: alignment }}>
        <div className="max-w-4xl mx-auto">
          <h1 
            className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent" 
            style={{ fontSize: `${nameSize}px`, fontWeight: 'bold', marginBottom: '8px' }}
          >
            {name}
          </h1>
          {title && (
            <p style={{ fontSize: `${titleSize}px`, color: titleColor, fontStyle: 'italic' }}>
              {title}
            </p>
          )}
        </div>
      </div>
    );
  }

  // Minimal Style
  if (nameStyle === 'minimal') {
    return (
      <div style={{ backgroundColor, padding: `${padding}px`, textAlign: alignment }}>
        <div className="max-w-4xl mx-auto">
          <h1 style={{ fontSize: `${nameSize}px`, color: nameColor, fontWeight: '600', marginBottom: '4px' }}>
            {name}
          </h1>
          {title && (
            <p style={{ fontSize: `${titleSize}px`, color: titleColor, fontWeight: '300' }}>
              {title}
            </p>
          )}
        </div>
      </div>
    );
  }

  // Bold Style
  if (nameStyle === 'bold') {
    return (
      <div style={{ backgroundColor, padding: `${padding}px`, textAlign: alignment }}>
        <div className="max-w-4xl mx-auto">
          <h1 
            style={{ 
              fontSize: `${nameSize}px`, 
              color: nameColor, 
              fontWeight: '900', 
              marginBottom: '12px',
              letterSpacing: '-0.02em'
            }}
          >
            {name}
          </h1>
          {title && (
            <p 
              className="uppercase tracking-wide"
              style={{ fontSize: `${titleSize}px`, color: titleColor, fontWeight: 'bold' }}
            >
              {title}
            </p>
          )}
        </div>
      </div>
    );
  }

  return null;
};

